class AuraAccordion {

  constructor(element) {

    this.element = element;

    this.trigger = element.querySelector('.aura-accordion__trigger');
    this.content = element.querySelector('.aura-accordion__content');

    if (!this.trigger || !this.content) return;

    // Non-exclusive groups (filter sidebar + filter overlay) allow multiple
    // open at once. Only Price + Brand auto-open via markup; the rest stay
    // collapsed but any number can be opened together.
    this.exclusive = !(
      element.classList.contains('aura-accordion--sidebar') ||
      element.classList.contains('aura-accordion--filters')
    );

    // If the markup rendered this group pre-opened, initialise it to a real
    // open state (visible content, auto height) instead of the CSS default
    // of height:0 — otherwise the first click would just close it.
    if (element.classList.contains('is-open')) {
      this.content.hidden = false;
      this.content.style.height = 'auto';
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    this.bindEvents();

  }

  bindEvents() {

    this.trigger.addEventListener('click', () => this.toggle());

  }

  open() {

    if (this.exclusive) {
      const group = this.element.parentElement;
      group
        .querySelectorAll('.aura-accordion.is-open')
        .forEach(item => {
          if (item === this.element) return;
          item.auraAccordion?.close();
        });
    }

    this.content.hidden = false;

    this.content.style.height = '0px';

    requestAnimationFrame(() => {

      this.element.classList.add('is-open');

      this.trigger.setAttribute('aria-expanded', 'true');

      this.content.style.height =
        this.content.scrollHeight + 'px';

    });

    const onTransitionEnd = () => {

      this.content.style.height = 'auto';

      this.content.removeEventListener('transitionend', onTransitionEnd);

    };

    this.content.addEventListener('transitionend', onTransitionEnd);

  }

  close() {

    this.content.style.height =
      this.content.scrollHeight + 'px';

    requestAnimationFrame(() => {

      this.element.classList.remove('is-open');

      this.trigger.setAttribute('aria-expanded', 'false');

      this.content.style.height = '0px';

    });

    const onTransitionEnd = () => {

      this.content.hidden = true;

      this.content.removeAttribute('style');

      this.content.removeEventListener('transitionend', onTransitionEnd);

    };

    this.content.addEventListener('transitionend', onTransitionEnd);

  }

  toggle() {

    if (this.element.classList.contains('is-open')) {

      this.close();

      return;

    }

    this.open();

  }

}

function initAuraAccordions() {

  document
    .querySelectorAll('.aura-accordion')
    .forEach(element => {

      if (element.auraAccordion) return;

      element.auraAccordion = new AuraAccordion(element);

    });

}

document.addEventListener('DOMContentLoaded', initAuraAccordions);

/* Callers that replace DOM containing accordions (e.g. an AJAX section
   swap) call this to bind the freshly-inserted ones without double-binding
   accordions that already survived the swap untouched. */
window.AuraAccordion = { init: initAuraAccordions };
